import {
  DEFAULT_NOTE_BORDER_SIZE,
  DEFAULT_NOTE_BORDER_STYLE,
  DEFAULT_NOTE_CORNER,
  DEFAULT_NOTE_SHADOW,
  type NoteProps,
} from '@blocksuite/affine-model';

export const DEFAULT_EDGELESS_NOTE_STYLE = {
  borderRadius: DEFAULT_NOTE_CORNER,
  borderSize: DEFAULT_NOTE_BORDER_SIZE,
  borderStyle: DEFAULT_NOTE_BORDER_STYLE,
  shadowType: DEFAULT_NOTE_SHADOW,
} satisfies NoteProps['edgeless']['style'];

export function resolveEdgelessNoteStyle(
  edgeless: Partial<NoteProps['edgeless']> | null | undefined
): NoteProps['edgeless']['style'] {
  return {
    ...DEFAULT_EDGELESS_NOTE_STYLE,
    ...edgeless?.style,
  };
}
